import { WorkosUserMappingModel } from "./WorkosUserMapping.model";

export class WorkosUserMapping extends WorkosUserMappingModel {
    // Add custom methods here
}
